import Button from '../../Button'
import { Container } from '../Container'

import { INLINE_BUTTON_SIZES } from './Buttons.constants'

import * as styles from './Buttons.module.css'

import PlusIcon from '../../../icons/plus.svg'

export function IconGrey() {
  return (
    <>
      <Container label='Button, icon, grey, grey, sizes - 24px, 16px'>
        {INLINE_BUTTON_SIZES.map(size => (
          <Button.Icon
            isGrey
            Icon={PlusIcon}
            className={styles.margin}
            height={size}
            key={size}
          />
        ))}
      </Container>
      <Container label='Button, icon, grey, disabled, sizes - 24px, 16px'>
        {INLINE_BUTTON_SIZES.map(size => (
          <Button.Icon
            disabled
            isGrey
            Icon={PlusIcon}
            className={styles.margin}
            height={size}
            key={size}
          />
        ))}
      </Container>
      <Container label='Button, icon, grey, with loader, sizes - 24px, 16px'>
        {INLINE_BUTTON_SIZES.map(size => (
          <Button.Icon
            isGrey
            isLoading
            Icon={PlusIcon}
            className={styles.margin}
            height={size}
            key={size}
          />
        ))}
      </Container>
      <Container label='Button, icon, grey, with skeleton, sizes - 24px, 16px'>
        {INLINE_BUTTON_SIZES.map(size => (
          <Button.Icon
            isGrey
            isSkeleton
            Icon={PlusIcon}
            className={styles.margin}
            height={size}
            key={size}
          />
        ))}
      </Container>
    </>
  )
}
